export default "__VITE_ASSET__Dv0JkdRN__"